import { render } from "./LetsTalkThankYou.vue?vue&type=template&id=73721b80"
import script from "./LetsTalkThankYou.vue?vue&type=script&lang=js"
export * from "./LetsTalkThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__